/*
 * @Author: xulihuan
 * @Date:   2017-12-11 18:32:51
 * @Last Modified by:   联想
 * @Last Modified time: 2017-12-12 18:37:03
 */

const FmAudioShare = resolve =>
  require(['../../../views/fm/FmAudioShare'], resolve)
const FmListShare = resolve =>
  require(['../../../views/fm/FmListShare'], resolve)
const FmStationShare = resolve =>
  require(['../../../views/fm/FmStationShare'], resolve)

export default [
  {
    path: '/fm-audio-share',
    component: FmAudioShare
  },
  {
    path: '/fm-list-share',
    component: FmListShare
  },
  {
    path: '/fm-station-share',
    component: FmStationShare
  }
]



// WEBPACK FOOTER //
// ./src/router/page/fm/index.js